import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { MdArrowForward } from "react-icons/md";

export default function CallToAction() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return null;
  }

  return (
    <section className="cta-section">
      <div className="container cta-inner" data-aos="fade-up">
        <div>
          <p className="section-kicker">Request Security Support</p>
          <h2>Protect your people, property, and operations.</h2>
        </div>
        <button className="btn-runzewe btn-runzewe-primary" onClick={() => appContext.navTo({ item: "contact" })}>
          <span>Contact Runzewe</span>
          <MdArrowForward />
        </button>
      </div>
    </section>
  );
}
